import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import GroupView from '../../components/GroupView';

const reducer = (state, action) => {
  switch (action.type) {
    case 'setOrder': {
      let newOrder = 'desc';
      if (state.order === 'desc') {
        newOrder = 'asc';
      } else if (state.order === 'asc') {
        newOrder = '';
      }
      return { ...state, order: newOrder };
    }
    case 'setSelected':
      return { ...state, selected: action.value };
    default:
      throw new Error();
  }
};

const AssetClass = ({ data, assetClassName }) => {
  const [state /* , dispatch */] = useReducer(reducer, {
    order: 'default',
    selected: Object.keys(data.groups).map((x) => Number(x)),
  });

  const filteredAndOrderedData = () => {
    const aux = [].concat(
      ...data.groups
        .filter((_group, index) => state.selected.indexOf(index) > -1)
        .map((group) => group.underlyingList),
    );

    switch (state.order) {
      case 'asc':
        aux.sort((a, b) => a.chg - b.chg);
        break;
      case 'desc':
        aux.sort((a, b) => b.chg - a.chg);
        break;
      default:
        if (aux.length > 0 && aux[0].order) {
          aux.sort((a, b) => a.order - b.order);
        }
        break;
    }
    return aux;
  };

  return (
    <GroupView
      data={{ underlyingList: filteredAndOrderedData() }}
      assetClassName={assetClassName}
    />
  );
};
AssetClass.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    groups: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  }).isRequired,
  assetClassName: PropTypes.string.isRequired,
};

export default AssetClass;
